<template>
  <div id="app">
    <Header></Header>
    <div class="app-body">
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view/>
      </transition>
    </div>
  </div>
</template>
<script>
import Header from './components/layout/Header'
export default {
  name: 'App',
  components: {
    Header
  },
  mounted () {
    /**
     * 目前因為在問題頁、還有彈出視窗都會需要用到第一二題的選單
     * 所以暫時先改成在進網站後就先取得一次，並存在 store 中
     **/
    this.$store.dispatch('getQuestionList')
  }
}
</script>

<style lang='scss'>
.app-body {
  padding-top: 50px;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue